import idbService from '../../services/idbService';
import { minutesToMilliseconds } from '../../helpers';
import { usuarioService } from '../../services/usuarioService';
import { empresaService } from '../../services/empresaService';
import { pedidoService } from '../../services/pedidoService';
import { clienteService } from '../../services/clienteService';
import { produtoService } from '../../services/produtoService';
import { unidadeService } from '../../services/unidadeService';
import { tipoDocumentoService } from '../../services/tipoDocumentoService';
import { condicaoPagamentoService } from '../../services/condicaoPagamentoService';
import { tabelaPrecoService } from '../../services/tabelaPrecoService';

const state = {
  loading: false,
  timeout_backup: null
}

const getters = {
  loading: state => state.loading
}

const actions = {
  async restoreBackup({ dispatch }, backup) {
    dispatch('clearAllStates');

    // Clear all stores
    await idbService.clearStore('empresas');
    await idbService.clearStore('saidas');
    await idbService.clearStore('clientes');
    await idbService.clearStore('produtos');
    await idbService.clearStore('unidades');
    await idbService.clearStore('tiposDocumento');
    await idbService.clearStore('condicoesPagamento');
    await idbService.clearStore('tabelasPreco');

    // Add backup to indexedDb
    await empresaService.addEmpresas(backup.empresas);
    await pedidoService.addPedidos(backup.saidas);
    await clienteService.addClientes(backup.clientes);
    await produtoService.addProdutos(backup.produtos);
    await unidadeService.addUnidades(backup.unidades);
    await tipoDocumentoService.addTiposDocumento(backup.tipos_documento);
    await condicaoPagamentoService.addCondicoesPagamento(backup.condicoes_pagamento);
    await tabelaPrecoService.addTabelasPreco(backup.tabelas_preco);
  },
  async syncBackend({ rootGetters, dispatch }) {
    console.log('Fetching from backend...');
    // Fetch from backend
    await dispatch('fetchEmpresasAPI');
    await dispatch('fetchPedidosAPI');
    await dispatch('fetchClientesAPI');
    await dispatch('fetchProdutosAPI');
    await dispatch('fetchUnidadesAPI');
    await dispatch('fetchTiposDocumentoAPI');
    await dispatch('fetchCondicoesPagamentoAPI');
    await dispatch('fetchTabelasPrecoAPI');
    await dispatch('fetchCatalogosAPI');

    console.log('Sending to backend...');
    // Send to backend
    await dispatch('fetchClientes');
    await dispatch('sendClientesAPI');
    await dispatch('fetchPedidos');
    await dispatch('sendPedidosAPI', rootGetters.pedidos);

    console.log('Sincronização finalizada.');
  },
  async verifyAndSendBackupOnline({ rootGetters, state, commit, dispatch }) {
    commit('CLEAR_TIMEOUT_BACKUP');

    console.log(`Verificando registros modificados...`);

    const {
      usuario,
      isPedidosModified,
      isClientesModified,
      isProdutosModified,
      isUnidadesModified,
      isEmpresasModified,
      isCondicoesPagamentoModified,
      isTiposDocumentoModified,
      isTabelasPrecoModified,
      isCatalogosModified,
    } = rootGetters;
    
    if (isPedidosModified) {
      const { pedidos } = rootGetters;

      console.log(`Enviando ${pedidos.length} pedido(s)...`);

      try {
        await usuarioService.setBackups(usuario._id, 'saidas', pedidos);
        commit('SET_IS_PEDIDOS_MODIFIED', false);
      } catch (error) {
        console.log(error);
      }
    }

    if (isClientesModified) {
      const { clientes } = rootGetters;

      console.log(`Enviando ${clientes.length} cliente(s)...`);

      try {
        await usuarioService.setBackups(usuario._id, 'clientes', clientes);
        commit('SET_IS_CLIENTES_MODIFIED', false);
      } catch (error) {
        console.log(error);
      }
    }

    if (isProdutosModified) {
      const { produtos } = rootGetters;

      console.log(`Enviando ${produtos.length} produto(s)...`);

      try {
        await usuarioService.setBackups(usuario._id, 'produtos', produtos);
        commit('SET_IS_PRODUTOS_MODIFIED', false);
      } catch (error) {
        console.log(error);
      }
    }

    if (isUnidadesModified) {
      const { unidades } = rootGetters;

      console.log(`Enviando ${unidades.length} unidade(s)...`);

      try {
        await usuarioService.setBackups(usuario._id, 'unidades', unidades);
        commit('SET_IS_UNIDADES_MODIFIED', false);
      } catch (error) {
        console.log(error);
      }
    }

    if (isEmpresasModified) {
      const { empresas } = rootGetters;

      console.log(`Enviando ${empresas.length} empresa(s)...`);

      try {
        await usuarioService.setBackups(usuario._id, 'empresas', empresas);
        commit('SET_IS_EMPRESAS_MODIFIED', false);
      } catch (error) {
        console.log(error);
      }
    }

    if (isCondicoesPagamentoModified) {
      const { condicoesPagamento } = rootGetters;

      console.log(`Enviando ${condicoesPagamento.length} condicao(oes) pagamento...`);

      try {
        await usuarioService.setBackups(usuario._id, 'condicoes_pagamento', condicoesPagamento);
        commit('SET_IS_CONDICOES_PAGAMENTO_MODIFIED', false);
      } catch (error) {
        console.log(error);
      }
    }

    if (isTiposDocumentoModified) {
      const { tiposDocumento } = rootGetters;

      console.log(`Enviando ${tiposDocumento.length} tipo(s) documento...`);

      try {
        await usuarioService.setBackups(usuario._id, 'tipos_documento', tiposDocumento);
        commit('SET_IS_TIPOS_DOCUMENTO_MODIFIED', false);
      } catch (error) {
        console.log(error);
      }
    }

    if (isTabelasPrecoModified) {
      const { tabelasPreco } = rootGetters;

      console.log(`Enviando ${tabelasPreco.length} tabela(s) preco...`);

      try {
        await usuarioService.setBackups(usuario._id, 'tabelas_preco', tabelasPreco);
        commit('SET_IS_TABELAS_PRECO_MODIFIED', false);
      } catch (error) {
        console.log(error);
      }
    }

    if (isCatalogosModified) {
      const { catalogos } = rootGetters;

      console.log(`Enviando ${catalogos.length} catalogo(s)...`);

      try {
        await usuarioService.setBackups(usuario._id, 'catalogos', catalogos);
        commit('SET_IS_CATALOGOS_MODIFIED', false);
      } catch (error) {
        console.log(error);
      }
    }

    console.log('Backup finalizado');

    const nextBackupTime = minutesToMilliseconds(rootGetters.backupTimeInMinutes);

    console.log(`Próximo backup agendado para: ${new Date(new Date().getTime() + nextBackupTime)}`);

    state.timeout_backup = setTimeout(() => {
      dispatch('verifyAndSendBackupOnline');
    }, nextBackupTime);
  },
  clearAllStates({ commit }) {
    commit('CLEAR_CLIENTES_STATE');
    commit('CLEAR_CONDICOES_PAGAMENTO_STATE');
    commit('CLEAR_PEDIDOS_STATE');
    commit('CLEAR_PRODUTOS_STATE');
    commit('CLEAR_TABELAS_PRECO_STATE');
    commit('CLEAR_TIPOS_DOCUMENTO_STATE');
    commit('CLEAR_UNIDADES_STATE');
    commit('CLEAR_EMPRESAS_STATE');
    commit('CLEAR_CATALOGOS_STATE');
  },
}

const mutations = {
  SET_LOADING: (state, loading) => state.loading = loading,
  CLEAR_TIMEOUT_BACKUP: state => clearTimeout(state.timeout_backup)
}

export default {
  state,
  actions,
  getters,
  mutations
}